import type { SVGProps } from 'react';

const SvgLogistics = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M17.27 12.53h1.5V7.39a.76.76 0 0 0-.77-.75h-5.12v1.5h3.32L2.72 21.63A14.2 14.2 0 0 1 1.58 16 14.44 14.44 0 0 1 16 1.58 14.28 14.28 0 0 1 26.4 6l1.09-1A15.93 15.93 0 0 0 1.82 23.26a.78.78 0 0 0 .56.4h.11a.75.75 0 0 0 .51-.21L17.27 9.2ZM30 8.43a.77.77 0 0 0-.54-.43.79.79 0 0 0-.64.21L15.05 22v-3.3h-1.5v5.13a.75.75 0 0 0 .75.75h5.14v-1.5h-3.33l13-13A14.43 14.43 0 0 1 16 30.42a14.34 14.34 0 0 1-10.23-4.25l-1.06 1.06A15.93 15.93 0 0 0 30 8.43" />
    </g>
  </svg>
);

export default SvgLogistics;
